import React, { useState, useEffect } from 'react';
import MenuGaveta from './MenuGaveta';
import logoImg from '../assets/logo-paws.png'; 

const Header = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Efeito de sombra ao rolar a página
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 900);
    };
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);
    return () => {
        window.removeEventListener('resize', handleResize);
        window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Estilo dinâmico para a sombra do header branco
  const headerShadowStyle = scrolled ? { boxShadow: '0 4px 20px rgba(0,0,0,0.1)' } : {};

  return (
    <>
      {/* O Wrapper agora é 100% branco e fixo no topo */}
      <div style={{
          ...(isMobile ? styles.mobileWrapper : styles.desktopWrapper),
          ...headerShadowStyle
      }}>
        <header style={isMobile ? styles.mobileHeader : styles.desktopHeader}>
          
          {/* --- ÁREA ESQUERDA --- */}
          <div style={styles.leftArea}>
            {isMobile ? (
              <button onClick={() => setMobileMenuOpen(true)} style={styles.hamburgerBtn}>
                <span style={{fontSize: '1.8rem'}}>☰</span>
              </button>
            ) : (
              <nav style={styles.navDesktop}>
                <button onClick={() => scrollToSection('home')} style={styles.link}>Início</button>
                <button onClick={() => scrollToSection('depoimentos')} style={styles.link}>Resultados</button>
                <button onClick={() => scrollToSection('faq')} style={styles.link}>Dúvidas</button>
              </nav>
            )}
          </div>

          {/* --- ÁREA CENTRAL (Logo) --- */}
          <div style={styles.centerArea}>
            <img 
              src={logoImg} 
              alt="Paws Logo" 
              style={isMobile ? styles.logoMobile : styles.logoDesktop} 
            />
          </div>

          {/* --- ÁREA DIREITA (Botão Comprar) --- */}
          <div style={styles.rightArea}>
            <button 
              onClick={() => scrollToSection('ofertas')} 
              style={isMobile ? styles.ctaMobile : styles.ctaDesktop}
            >
              {isMobile ? 'Comprar' : 'COMPRAR AGORA'}
            </button>
          </div>

        </header>
      </div>

      {mobileMenuOpen && (
        <MenuGaveta onClose={() => setMobileMenuOpen(false)} />
      )}
    </>
  );
};

const styles = {
  desktopWrapper: {
    width: '100%',
    backgroundColor: '#ffffff', 
    position: 'sticky', 
    top: 0,
    zIndex: 1000,
    transition: 'box-shadow 0.3s ease'
  },
  mobileWrapper: {
    width: '100%',
    backgroundColor: '#ffffff', // Fundo Branco
    position: 'sticky', 
    top: 0,
    zIndex: 1000,
    transition: 'box-shadow 0.3s ease'
  },

  // --- HEADERS  ---
  desktopHeader: {
    backgroundColor: 'transparent', 
    width: '100%',
    maxWidth: '1200px', 
    margin: '0 auto', 
    height: '80px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 30px',
  },
  mobileHeader: {
    backgroundColor: 'transparent',
    width: '100%',
    height: '70px',
    display: 'flex',
    alignItems: 'center', // ISSO GARANTE A CENTRALIZAÇÃO VERTICAL
    justifyContent: 'space-between',
    padding: '0 20px'
  },

  // --- ÁREAS DE ALINHAMENTO ---
  leftArea: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  centerArea: {
    flex: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: '150px'
  },
  rightArea: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },

  navDesktop: {
    display: 'flex',
    gap: '30px',
    alignItems: 'center'
  },
  link: {
    background: 'none',
    border: 'none',
    outline: 'none',
    cursor: 'pointer',
    color: '#513D8B', // Link agora é ROXO
    fontSize: '0.9rem',
    fontWeight: '700',
    fontFamily: '"Commissioner", sans-serif',
    padding: '5px 0',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    transition: 'opacity 0.2s',
    opacity: '1'
  },
  logoDesktop: {
    height: '50px', // Aumentei um pouco
    width: 'auto',
    cursor: 'pointer',
    objectFit: 'contain',
    display: 'block'
  },
  logoMobile: {
    height: '40px',
    width: 'auto',
    objectFit: 'contain',
    display: 'block'
  },

  ctaDesktop: {
    backgroundColor: '#32CD32', 
    color: '#ffffff', // Texto Branco
    border: 'none',
    outline: 'none',
    padding: '14px 35px',
    borderRadius: '40px',
    fontWeight: '900',
    fontSize: '0.9rem',
    cursor: 'pointer',
    fontFamily: '"Commissioner", sans-serif',
    boxShadow: '0 4px 10px rgba(81, 61, 139, 0.3)', // Sombra roxa
    textTransform: 'uppercase',
    transition: 'transform 0.2s'
  },
  ctaMobile: {
    backgroundColor: '#32CD32', // ERA ROXO (#513D8B), AGORA É VERDE
    color: '#ffffff', 
    border: 'none',
    outline: 'none',
    padding: '10px 20px',
    borderRadius: '30px',
    fontWeight: 'bold',
    fontSize: '0.85rem',
    cursor: 'pointer',
    fontFamily: '"Commissioner", sans-serif',
    display: 'flex',
    alignItems: 'center',
    textTransform: 'uppercase', // Adicionei para ficar igual
    boxShadow: '0 4px 10px rgba(50, 205, 50, 0.4)', // Adicionei sombra verde
    gap: '5px'
  },
  hamburgerBtn: {
    background: 'none',
    border: 'none',
    outline: 'none',
    color: '#513D8B', 
    padding: 0,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center'
  }
};

export default Header;